export enum Variant {
  Size = 'size',
  Color = 'color',
  Accommodation = 'accommodation',
  Age = 'age',
  DateTime = 'date_time',
  Day = 'day',
  Time = 'time',
  Hour = 'hour',
  Weight = 'weight',
  Volume = 'volume',
  Vehicle = 'vehicle',
  Custom = 'custom',
}

export enum SizeVariant {
  XS = 'xs',
  S = 's',
  M = 'm',
  L = 'l',
  XL = 'xl',
  XXL = 'xxl',
  XXXL = 'xxxl',
}

export enum AccommodationVariant {
  SINGLE = 'single',
  DOUBLE_SINGLE = 'double_single',
  DOUBLE = 'double',
  TRIPLE_SINGLE = 'triple_single',
  TRIPLE_DOUBLE_SINGLE = 'triple_double_single',
  QUADRUPLE_SINGLE = 'quadruple_single',
  QUADRUPLE_DOUBLE = 'quadruple_double',
  QUADRUPLE_DOUBLE_SINGLE = 'quadruple_double_single',
}

export enum AgeVariant {
  ADULT = 'adult',
  YOUNGSTER = 'youngster',
  CHILD = 'child',
  INFANT = 'infant',
}

export enum VehicleVariant {
  MOUNTAIN_BIKE = 'mountain_bike',
  ELECTRIC_BIKE = 'electric_bike',
  CITY_BIKE = 'city_bike',
  CITY_CAR = 'city_car',
  SUV = 'suv',
  CROSSOVER = 'crossover',
  BERLINA = 'berlina',
  COUPE = 'coupe',
  OFF_ROAD = 'off_road',
  VAN = 'van',
  BUS = 'bus',
  SCOOTER50 = 'scooter50cc',
  SCOOTER125 = 'scooter125cc',
  MOTORBIKE = 'motorbike',
}

export const variantOrder: { key: Variant; value: number }[] = [
  {
    key: Variant.Age,
    value: 0,
  },
  {
    key: Variant.Hour,
    value: 1,
  },
  {
    key: Variant.Day,
    value: 2,
  },
  {
    key: Variant.DateTime,
    value: 3,
  },
  {
    key: Variant.Time,
    value: 4,
  },
  {
    key: Variant.Vehicle,
    value: 5,
  },
  {
    key: Variant.Color,
    value: 6,
  },
  {
    key: Variant.Size,
    value: 7,
  },
  {
    key: Variant.Weight,
    value: 8,
  },
  {
    key: Variant.Volume,
    value: 9,
  },
  {
    key: Variant.Accommodation,
    value: 10,
  },
  {
    key: Variant.Custom,
    value: 11,
  },
];
